module.exports = __webpack_public_path__ + "static/img/weibo-icon.a63bd71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weibo-icon.png
// module id = dGJN
// module chunks = 1